<div class="container-box shadow-none">
  <div class="d-flex gap-3 align-items-center p-3">
    <img src="/assets/images/channel-wizards/step-icon2.webp" alt="" height="40" />
    <div>
      <h6 class="mb-0" i18n>Request Channel Manager Access</h6>
      <div class="text-sm" i18n>
        This section can take between 10 minutes and 2 hrs depending on the volume of requests.
      </div>
    </div>
  </div>
  <div class="border-top p-4 d-flex gap-5">
    <div class="flex-fill">
      <mat-accordion>
        <mat-expansion-panel [expanded]="true" #settings>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="step-number mr-2">1</div>
              <ng-container i18n>Connectivity Provider settings on Booking.com</ng-container>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <p>
              <ng-container i18n>Click on the</ng-container> <strong i18n>Account button</strong>
              <ng-container
                >at the top right, then click on the Channel Manager link in the drop-down menu.</ng-container
              >
            </p>

            <p>
              <ng-container i18n>If you don't see the</ng-container> <strong i18n>Connectivity Provider</strong>
              <ng-container i18n
                >option, please contact your Booking.com support team to request the commercial approval and make sure
                the sign up tool in your extranet is activated.</ng-container
              >
            </p>
            <div class="text-right">
              <button class="btn btn-light-info" (click)="startConnection.open()">
                <ng-container i18n>Next</ng-container> <i class="cs-icon cs-icon-arrow-down-long"></i>
              </button>
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel #startConnection>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="step-number mr-2">2</div>
              <ng-container i18n>To connect to AdvanceCM from Booking.com side</ng-container>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <p i18n>To connect to the Advance Channel Manager (ACM) from Booking.com:</p>
            <ol class="pl-3">
              <li><ng-container i18n>Use the search bar to type</ng-container> <strong i18n>Tokeet</strong>.</li>
              <li>
                <ng-container i18n>Select</ng-container> <strong i18n>Tokeet</strong>
                <ng-container i18n>from the results.</ng-container>
              </li>
              <li>
                <ng-container i18n>Choose the features you want to connect and sync, such as:</ng-container>
                <ul class="pl-0">
                  <li i18n>Rates</li>
                  <li i18n>Reservations</li>
                  <li i18n>Reviews</li>
                  <li i18n>Reporting</li>
                  <li i18n>Guest messages</li>
                  <li i18n>Performance data and insights</li>
                </ul>
              </li>
              <li i18n>Click Connect to proceed.</li>
            </ol>
            <p>
              <ng-container i18n>Once completed, you'll be directed to the</ng-container>
              <strong i18n>Connection Request Completed</strong>
              <ng-container i18n>screen on Booking.com.</ng-container>
              <br />
              <ng-container i18n
                >If you need further help during the process, please don't hesitate to contact our support
                team</ng-container
              >
            </p>
            <div class="text-right">
              <button class="btn btn-light-info" (click)="enterPropertyId.open()">
                <ng-container i18n>Next</ng-container> <i class="cs-icon cs-icon-arrow-down-long"></i>
              </button>
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel #enterPropertyId>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="step-number mr-2">3</div>
              <ng-container i18n>Enter your Booking.com Property ID and finalize the connection</ng-container>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="mb-3">
            <mat-form-field2 [showLabel]="false" class="w-50">
              <input
                matInput
                i18n-placeholder
                placeholder="Enter Property ID"
                [formControl]="propertyIdCtrl"
                required
              />
              <mat-error i18n *ngIf="propertyIdCtrl.touched && propertyIdCtrl.hasError('required')">
                Property ID is required
              </mat-error>
              <mat-error i18n *ngIf="propertyIdCtrl.touched && propertyIdCtrl.hasError('pattern')">
                Property ID must be a number
              </mat-error>
            </mat-form-field2>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <div class="alert alert-danger d-flex align-items-center gap-3 mt-3 mb-0" *ngIf="connectError">
        <i class="cs-icon cs-icon-alert-triangle2"></i>
        <div class="flex-fill">{{ connectError.message }}</div>
        <button
          class="btn btn-light-danger"
          *ngIf="connectError.retryable"
          [disabled]="propertyIdCtrl.invalid || isConnecting"
          (click)="onConnect(propertyIdCtrl)"
          i18n
        >
          Retry
        </button>
      </div>
    </div>
    <div style="max-width: 350px; min-width: 350px">
      <img src="/assets/images/channel-wizards/bdc/bdc-settings.webp" alt="" class="w-100" *ngIf="settings.expanded" />
      <img
        src="/assets/images/channel-wizards/bdc/start-connection.webp"
        alt=""
        class="w-100"
        *ngIf="startConnection.expanded"
      />
      <img
        src="/assets/images/channel-wizards/bdc/enter-property-id.webp"
        alt=""
        class="w-100"
        *ngIf="enterPropertyId.expanded"
      />
    </div>
  </div>
</div>
<div class="mt-3 d-flex align-items-center justify-content-between">
  <button class="btn btn-outline-light" (click)="prev.emit()">
    <i class="cs-icon cs-icon-arrow-left-long text-xxs"></i>
    <ng-container i18n>Previous</ng-container>
  </button>
  <button
    class="btn btn-secondary-info"
    matTooltip="Please enter property ID to connect to Booking.com"
    i18n-matTooltip
    [disabled]="propertyIdCtrl.invalid || isConnecting"
    (click)="onConnect(propertyIdCtrl)"
  >
    <ng-container i18n>Connect</ng-container>
    <i class="far fa-spin fa-spinner" *ngIf="isConnecting"></i>
    <i class="cs-icon cs-icon-arrow-right-long text-xxs" *ngIf="!isConnecting"></i>
  </button>
</div>
